import getMomentDateObj from "./getMomentDateObj"
import getMomentNow from "./getMomentNow"
import isCurrentPerformance from "./isCurrentPerformance"
import naturalCompare from "./naturalCompareStrings"

const sortPerformancesAfterAttributes = (performances, attributeDays, translation) => {
    performances.map(performance => {
        const { attributes, timeUtc } = performance
        const { timezone } = translation
        const dateNow = getMomentNow(timezone)

        if(isCurrentPerformance(dateNow, getMomentDateObj(timeUtc, timezone))) {
            const attributesWithoutDigital = _.reject(attributes, attr => {
                return attr.id === 'digital'
            })
    
            const technologyAttributesSorted = attributesWithoutDigital.sort((a, b) => naturalCompare(a.name, b.name))
            const attributeKeys = []
            
            technologyAttributesSorted && technologyAttributesSorted.map(attribute => {
                const attributeIdWithoutSpace = attribute.id.trim();
                attributeKeys.push(attributeIdWithoutSpace)
            })
    
            const attributeKey = attributeKeys.join('-')
    
            if(!attributeDays.hasOwnProperty(attributeKey)) {
                attributeDays[attributeKey] = {
                    attributes: attributesWithoutDigital,
                    performances: []
                }
            }
    
            if(!_.contains(attributeDays[attributeKey].performances, performance)) {
                attributeDays[attributeKey].performances.push(performance)
            }
        }
    })

    return attributeDays
}

export default sortPerformancesAfterAttributes